import React, {memo} from 'react';
import { Redirect, Route as ReactRoute, Switch } from '@okapi/router-react';
import { useErrorCode } from 'common/hooks/use-error-code';
import { Route, routes } from './routes';

export const Routes = memo(() => <NestedRoutes routesTree={routes} />);

export const NestedRoutes: React.FC<{ routesTree: Route[] | undefined }> = ({ routesTree }) => {
    const errorCode = useErrorCode();

    if (errorCode) {
        return <Redirect to={`/${errorCode}`} />;
    }

    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /* @ts-ignore */
        <Switch>
            {routesTree?.map(({ routes: nestedRoutes, component: Component, path, key, strict, exact }) => (
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                <ReactRoute path={path} key={key} strict={strict} exact={exact}>
                    {Component ? (
                        <Component>
                            <NestedRoutes routesTree={nestedRoutes} />
                        </Component>
                    ) : (
                        <NestedRoutes routesTree={nestedRoutes} />
                    )}
                </ReactRoute>
            ))}
        </Switch>
    );
};